<template>
  <form-group
    :errors="internalErrors"
    :label="label"
    @focus="focus"
    class="delivery-lead-time-input"
  >
    <div class="uk-grid-small" uk-grid>
      <div class="uk-width-small">
        <input
          :class="inputCss"
          :disabled="disabled"
          @input="onInputMin"
          class="uk-input delivery-lead-time-input__min"
          min="0"
          ref="primaryInput"
          step="1"
          type="number"
          v-model.number="min"
        />
      </div>
      <div class="delivery-lead-time-input__input-separator">-</div>
      <div class="uk-width-small">
        <input
          :class="inputCss"
          :disabled="disabled"
          @input="onInputMax"
          class="uk-input delivery-lead-time-input__max"
          min="0"
          ref="secondaryInput"
          step="1"
          type="number"
          v-model.number="max"
        />
      </div>
      <div>
        <select
          :class="inputCss"
          :disabled="disabled"
          @change="onInput"
          class="uk-select delivery-lead-time-input__unit"
          v-model="unit"
        >
          <option
            :key="availableUnit"
            :value="availableUnit"
            v-for="availableUnit in availableUnits"
          >{{translateUnit(availableUnit)}}</option>
        </select>
      </div>
    </div>
  </form-group>
</template>

<script>
import { camelCase } from 'lodash';
import ComplexInput from '@/mixins/ComplexInput';

const AVAILABLE_UNITS = ['DAYS', 'WEEKS'];

export default {
  name: 'delivery-lead-time-input',
  mixins: [ComplexInput],
  data() {
    const value = { min: null, max: null, unit: AVAILABLE_UNITS[0] };
    if (this.value) {
      value.min = this.value.min;
      value.max = this.value.max;
      value.unit = this.value.unit;
    }

    return {
      ...value,
      availableUnits: AVAILABLE_UNITS,
    };
  },
  watch: {
    value(value) {
      if (value) {
        this.min = value.min;
        this.max = value.max;
        this.unit = value.unit;
      } else {
        this.min = null;
        this.max = null;
        // do not change the unit
      }
    },
  },
  computed: {
    valueIsPresent() {
      return this.min && this.max && this.unit;
    },
  },
  methods: {
    onInputMin() {
      if (!this.min) {
        this.max = null;
      } else if (!this.max) {
        this.max = this.min;
      }
      if (this.min > this.max) {
        this.max = this.min;
      }
      this.onInput();
    },
    onInputMax() {
      if (!this.max) {
        this.min = null;
      } else if (!this.min) {
        this.min = this.max;
      }
      if (this.max < this.min) {
        this.min = this.max;
      }
      this.onInput();
    },
    onInput() {
      let value = null;
      if (this.valueIsPresent) {
        value = { min: this.min, max: this.max, unit: this.unit };
      }
      this.$emit('input', value);
    },
    translateUnit(unit) {
      let cardinality = 'plural';
      if (this.max === 1) {
        cardinality = 'singular';
      }
      const key = `units.deliveryLeadTimes.${cardinality}.${camelCase(unit)}`;
      return this.$t(key);
    },
  },
  i18n: {
    messages: {
      de: {
        fields: {
          min: 'von',
          max: 'bis',
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../theme/variables.scss";

.delivery-lead-time-input__input-separator {
  font-size: 1.4rem;
  font-weight: normal;
  line-height: 2.4rem;
  color: $global-muted-color;
}
</style>



// WEBPACK FOOTER //
// DeliveryLeadTimeInput.vue?deab5b46